export enum ProviderTypes {
  DMEPOSProvider = 'DMEPOS Provider',
  HealthPlanCaseManager = 'Health Plan Case Manager',
  HHAdmin = 'Admin Home Health',
  HHAgency = 'Home Health',
  HHBillingOffice = 'Billing Office',
  HospitalPlanner = 'Hospital CM/Discharge Planner',
  Physician = 'Physician',
  PostAcuteFacility = 'Post-Acute Facility',
  SDoHClinician = 'SDoH',
  SDoHProviderAdmin = 'SDoH Provider Admin',
  WCCClinician = 'WCC',
  WCCProviderAdmin = 'WCC Provider Admin',
  SpecialtyProviderAdmin = 'Specialty Program Provider Admin',
  SpecialtyClinician = 'Specialty Program Clinician',
  CHAPPProvider = 'CHAPP Provider',
}